<template>
    <div class="flex">
        <DateDropdown class="w-50 mr2" :imageUrl="dateImage" :value="value" @input="onDateChange($event)" />
        <TimeDropdown class="w-50 ml2" :value="time" @input="onTimeChange($event)" />
    </div>
</template>

<script>
import DateDropdown from '@/components/controls/DateDropdown.vue';
import TimeDropdown from '@/components/controls/TimeDropdown.vue';
import * as moment from 'moment';

export default {
    components: {
        DateDropdown,
        TimeDropdown
    },
    props: {
        dateImage: { type: String },
        value: { type: String }
    },
    methods: {
        onDateChange(date) {
            var original = moment(this.value);
            var hours = original.hours();
            var minutes = original.minutes();
            this.$emit(
                'input',
                moment(date)
                    .set({ hours, minutes })
                    .toJSON()
            );
        },
        onTimeChange(time) {
            var original = moment(this.value);
            var years = original.year();
            var months = original.month();
            var date = original.date();
            this.$emit(
                'input',
                moment(time, 'h:mma')
                    .set({ years, months, date })
                    .toJSON()
            );
        }
    },
    computed: {
        time() {
            return moment(this.value).format('h:mma');
        }
    }
};
</script>
